import React from 'react'
import { useSelector } from 'react-redux'

export const Contrato = () => {
    const {contrato} = useSelector(state => state.client)
    
    return (
        <div className="card contrato">
            <div className="card-body">
                <div className="card-title"> <h1>Contrato </h1> </div>
                <div dangerouslySetInnerHTML={{__html: contrato}} />
            </div>
        </div>
    )
}
